import styled, { css } from "styled-components/macro";
import { typography } from "src/utils/styledComponents/typography";
import { Typography } from "antd";
import { colors } from "src/theme/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  ${typography.CustomText("1em")}
  padding: 2em;
`;

export const Header = styled.h2`
  font-size: 1.5em;
  font-weight: 600;
  color: ${colors.primary[500]};
  padding: 1em 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.span`
  font-size: 1em;
  color: ${colors.primary[500]};
  opacity: 0.8;
  margin-bottom: 0.3rem;
  display: block;
  font-size: 12px;
`;

export const ImageContainer = styled.a`
  padding: 8px;
  background-color: rgba(232, 241, 255, 0.5);
  border-radius: 5px;
  cursor: pointer;
`;
export const DownloadIcon = styled.img`
  filter: invert(32%) sepia(99%) saturate(1740%) hue-rotate(205deg)
    brightness(99%) contrast(94%);
`;

export const Body = styled.div``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

export const Item = styled.li`
  list-style: none;
`;

export const Field = styled(Typography.Paragraph)<{ coppied?: any }>`
  &.ant-typography {
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid ${colors.primary[500]};
    border-radius: 5px;
    background-color: ${({ coppied }) => (coppied ? "#E8F1FF" : "transparent")};
    line-height: 1;
    padding: 12px 16px;
    font-size: 14px;
    color: rgb(0 0 0);
  }
`;

export const Flags = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 1.5em;
  font-size: 1rem;
`;

export const ActiveFlag = css`
  opacity: 1;
  border-bottom: 4px solid ${colors.primary[500]};
`;

export const Flag = styled.div<{ active?: boolean; disabled?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  padding: 0.75rem 0;
  background-color: ${colors.primary[50]};
  opacity: 0.27;
  transition: all 0.2s ease-in;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 0.4rem;
  transition: all 0.2s ease-in;
  ${({ active }) => active && ActiveFlag};
  ${({ disabled }) => (disabled ? "pointer-events:none;" : "")}
`;

export const CountryImg = styled.img`
  width: 21px;
  height: 21px;
  border-radius: 50%;
`;
